import React from "react";
import { AlephiumConnectButton } from "@alephium/web3-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut, faWallet } from "@fortawesome/free-solid-svg-icons";
import { formatAddress } from "../utils/Formatters";

interface HeaderProps {
}

const Header: React.FC<HeaderProps> = ({ }) => {
  return (
    <header className="w-full max-w-4xl mx-auto flex items-center justify-between px-6 py-4 text-white shadow-md relative">
      {/* Left: Logo */}
      <div className="absolute left-6 flex items-center space-x-2">
        {/* Desktop Logo */}
        <img
          src="/images/logo/logo.webp"
          alt="AlphPad"
          className="h-10 hidden sm:block"
        />

        {/* Mobile Logo */}
        <img
          src="/images/logo/favicon.webp"
          alt="AlphPad"
          className="h-8 block sm:hidden"
        />
      </div>

      {/* Center: Game Name */}
      <div className="text-xl sm:text-2xl font-bold text-center ml-14 sm:mx-auto">Rocket Range</div>

      {/* Right: Wallet Connect */}
      <div className="absolute right-6">
        <AlephiumConnectButton.Custom>
          {({ isConnected, disconnect, show, account }) => {
            return isConnected ? (
              <button
                onClick={disconnect}
                className="flex items-center justify-center p-2 sm:p-4 bg-red-600 text-white font-medium rounded-md shadow-md hover:bg-red-800 transition duration-300"
              >
                <span className="text-sm">{formatAddress(account?.address ?? "", undefined)}</span>
              </button>
            ) : (
              <button
                onClick={show}
                className="flex items-center justify-center p-2 sm:p-4 bg-red-600 text-white font-medium rounded-md shadow-md hover:bg-red-800 transition duration-300"
              >
                <FontAwesomeIcon className="text-lg" icon={faWallet} />
              </button>
            );
          }}
        </AlephiumConnectButton.Custom>
      </div>
    </header>
  );
};

export default Header;
